import { useNavigate, useLocation } from "react-router-dom";

export default function WebHeader() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <>
      <nav className="nav">
        <div className="wrap nav-inner">
          <div className="logo" onClick={() => navigate("/")}>
          
               <img src="/website/assets/image/logo.png" alt="Logo" height={30} />
          </div>
          <div className="nav-links" id="navLinks">
            <button
              className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
              onClick={() => navigate("/")}
            >
              Product
            </button>
            <button
              className={`nav-link ${location.pathname === "/features" ? "active" : ""}`}
              onClick={() => navigate("/features")}
            >
              Features
            </button>
            <button
              className={`nav-link ${location.pathname === "/pricing" ? "active" : ""}`}
              onClick={() => navigate("/pricing")}
            >
              Pricing
            </button>
            <button
              className={`nav-link ${location.pathname === "/contact" ? "active" : ""}`}
              onClick={() => navigate("/contact")}
            >
              Contact
            </button>
          </div>
          <div className="nav-cta">
            <button
              className="btn btn-ghost btn-sm"
              onClick={() => navigate("/login")}
              style={{background:"#ffffff"}}
            >
              Sign in
            </button>
            
            <button
              className="nav-mobile-toggle"
              onClick={() => document.getElementById("navLinks").classList.toggle("open")}
            >
              <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                <path d="M3 6h18M3 12h18M3 18h18" />
              </svg>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}